import React, { FC } from 'react';

import { ListCardGroup } from 'components/list-card-group';
import { t } from 'state/intl/translations';

import { Modifier } from '../../modifier/modifier';
import { IModifierData } from '../../modifier/types';

import { IModifierGroupProps } from './types';

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  selectedItem,
  isFullContainer = false,
}) => {
  return (
    <ListCardGroup
      isFullContainer={isFullContainer}
      items={modifiers}
      header={displayGroupName ? t(displayGroupName) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => (
        <Modifier
          {...modifierProps}
          key={`modifier-${modifierProps.modifier.name?.locale}`}
          onSelectionsChange={selections =>
            onModifierSelectionChange(selections, modifierProps.modifier)
          }
          selectedItem={selectedItem}
        />
      )}
    />
  );
};
